module.exports = __webpack_public_path__ + "static/media/gesture_recognition_video.c8887d53.mp4";